import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BASIC_CLIENT_INFO } from '@constants/data-service.constant';
import { DATA_UPDATE, HOME_URL, INICIO, PROFILE } from '@constants/url.constant';
import { ISolicitudResponse } from '@interfaces/solicitud-cambio-via-pago.response.interface';

import { VoucherProperties } from '@interfaces/voucher-properties.interface';
import { StorageService } from '@services/storage/storage.service';
import { Util } from '@shared/common/utils/util';


@Component({
    selector: 'app-voucher',
    templateUrl: './voucher.component.html',
    styleUrls: ['./voucher.component.scss'],
    standalone: false
})
export class VoucherComponent implements OnInit {

   @Input() voucherProperties: VoucherProperties;
  @Input() goBackFunction: () => void;
  @Input() serviceResponseStorageName: string;
  @Input() stepsStorageName: string;
  @Input() solicitudResponse: ISolicitudResponse;

  public infoSuccesEmail: string;
  public loading: boolean = false;
  public clientEmail: string;
  public serviceResponse: any;
  public steps: any;
  
  constructor(private readonly storageService: StorageService,
    private readonly router: Router,
    private readonly _util: Util
    ) { }

  ngOnInit() {
      void this.inicializarComponente();
  }

  private async inicializarComponente(){
    const clientInfo = await this.storageService.get(BASIC_CLIENT_INFO);
    this.serviceResponse = await this.storageService.get(this.serviceResponseStorageName);
    this.steps = await this.storageService.get(this.stepsStorageName);
    this.clientEmail = clientInfo.email;
    this.infoSuccesEmail = this.clientEmail ? this.voucherProperties.infoSuccesClientWithEmail.replace('?', this.clientEmail) : this.voucherProperties.infoSuccesClientWithoutEmail;
  }

  public goToYourData(): void {
    this.router.navigate([DATA_UPDATE,HOME_URL,PROFILE]);
  }

  goToAccounts() {
    this.router.navigate([INICIO]);
  }

  get hasEmail(): boolean {
    return !!this.clientEmail;
  }

}
